import { render, staticRenderFns } from "./InfoBaseTechnologies.vue?vue&type=template&id=0e79d240&scoped=true&"
import script from "./InfoBaseTechnologies.vue?vue&type=script&lang=js&"
export * from "./InfoBaseTechnologies.vue?vue&type=script&lang=js&"
import style0 from "./InfoBaseTechnologies.vue?vue&type=style&index=0&id=0e79d240&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e79d240",
  null
  
)

export default component.exports